import apiUrl from './../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import utility from './../../../utility/services/utility.service';
import Loader from './../../../shared/components/loader'
import Treeselect from '@riophae/vue-treeselect';
import { Validator } from 'vee-validate';
import iptracker from '../../../../views/components/commonfunction/iptracker';


export default {
  name: 'markAWBInvalid',
  components: {
    //VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    utility,
    vueMultiSelect,
    iptracker,
    Loader
  },
  data: function() {
    return {
	  picked: 1,		
      shipmentId: '',
      awbErr:'',
      finaldestination: '',
      msg: 'Maximum 10 AWBs allowed',
      comments: '',
      commenterr: '',
      isLoading:false,
      showAWBInvalid:false,
      selectedOrigin:{value:'',text:''},
      huberr: '',
      finalresult: [],
      userdetail: {},
      awbarr: [],
	  currentTab: 'First',
	  componentKey:1,
	  tabs: [
		{ key:'First', value:' Mark AWB Invalid'},
		{ key:'Second', value:' Mark PRQ Invalid'},
	  ],
	  prqErr:'',
	  prqcommenterr:'',
	  prqcomments:'',
	  showPRQInvalid:false,
	  finalprqresult:[],
	  prqarr: [],
	  pickupId:'',
	  prqId:'',

    }
  },
  computed: {
	currentTabComponent: function () {
	  this.picked=(this.currentTab=='First')?1:2;
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
  },
  methods: {
    async updateMarkAWBInvalid() {
      try {
        if(this.checkErr()){
          return false
        }
        this.commenterr = ''
        this.huberr = ''
        this.awbErr = ''
        this.isLoading = true
        let result =[];
        let temArr =[];
        let inputPayload ={}
        await Promise.all(this.awbarr.map(async awbNo =>{
          inputPayload = {
           "awb" : awbNo.trim(),
           "comments" : this.comments,
           "lastmodifiedby" : this.userName
          }
          this.isLoading = true

          result = await utility.MarkAWBInvalid(inputPayload);
          temArr.push({"awb":awbNo,"result":result.data.message});
          result = [];
          inputPayload = {}
        })
      )
      this.finalresult = temArr;
      this.getTraceIP(inputPayload)
      this.isLoading = false
        this.showAWBInvalid=true;
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmitSearch() {
      try {
      this.updateMarkAWBInvalid()
      } catch (err) {
        console.log(err);
      }
    },
    checkErr(){
      this.awbarr=[];
      let err = false
      this.awbarr = (this.shipmentId.split(','));
      if(this.awbarr.length >= 11) {
       err = true
       this.awbErr = 'Maximum 10 AWBs allowed'
     }
      if(this.comments.length > 500) {
        err = true
        this.commenterr = 'Maximum 500 characters allowed'
      }
      return err
    },
	checkPRQErr(){
		this.prqarr=[];
		let err = false
		this.prqarr = (this.prqId.split(','));
		if(this.prqarr.length >= 11) {
		 err = true
		 this.prqErr = 'Maximum 10 PRQs allowed'
	   }
		if(this.prqcomments.length > 500) {
		  err = true
		  this.prqcommenterr = 'Maximum 500 characters allowed'
		}
		return err
	},
    closeShowAWBInvalid(){
      this.showAWBInvalid=false;
      this.finalresult=[]
      this.reset();
    },
	closeShowPRQInvalid(){
      this.showPRQInvalid=false;
      this.finalprqresult=[]
      this.reset();
	},
    reset() {
      this.shipmentId = '',
      this.awbErr = '',
      this.prqErr = '',
      this.huberr = '',
      this.finaldestination = '',
      this.selectedOrigin = {value:'',text:''},
      this.awbarr = [],
	  this.prqarr = [],
	  this.prqId = '',
      this.commenterr = '',
	  this.prqcommenterr = '',
      this.comments = '',
	  this.prqcomments = '',
      this.$validator.reset();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.onSubmitSearch(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
	onPRQSubmit: function(event) {
		try {
		  if(this.prqId == null || this.prqId == undefined || this.prqId==''){
			this.$alertify.error("Pickup Request ID is Required");
			return false
		  }
		  if(this.prqcomments == null || this.prqcomments == undefined || this.prqcomments ==''){
			this.$alertify.error("Comment is Required");
			return false
		  }
		  this.onPRQSubmitSearch(event);
		} catch (error) {
			console.log('errors exist', this.errors)
		}
		//console.log("Event --",event)

		//this.$validator.validateAll().then((result) => {
		//  console.log("Result --",result)	
		//  if(!result){
		//	this.onPRQSubmitSearch(event);
		//  }
		//}).catch(() => {
		//  console.log('errors exist', this.errors)
		//});
	  },
    getTraceIP(data) {
      try {
        let payload = 
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/markAWBInvalid',
          "meta" : {
            "event" : `Mark Shipment Invalid`,
            "data" : data
          }
        }
        let result = iptracker.getTraceIP(payload);
      } catch (error) {
        console.log(error)
      }
      
    },
    async updateMarkPRQInvalid() {
		try {
		  if(this.checkPRQErr()){
			return false
		  }
		  this.prqcommenterr = ''
		  this.huberr = ''
		  this.prqErr = ''
		  this.isLoading = true
		  let result =[];
		  let temArr =[];
		  let inputPayload ={}
		  await Promise.all(this.prqarr.map(async prqNo =>{
			inputPayload = {
			 "pickuprequestid" : prqNo.trim(),
			 "comments" : this.prqcomments,
			 "lastmodifiedby" : this.userName
			}
			this.isLoading = true

			result = await utility.MarkPRQInvalid(inputPayload);
			temArr.push({"pickuprequest":prqNo,"result":result.data.message});
			result = [];
			inputPayload = {}
		  })
		)
		this.finalprqresult = temArr;
		this.getTraceIP(inputPayload)
		this.isLoading = false
		this.showPRQInvalid=true;
		} catch (err) {
		  console.log(err);
		}
	  },
	  async onPRQSubmitSearch() {
		try {
		this.updateMarkPRQInvalid()
		} catch (err) {
		  console.log(err);
		}
	  },
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/markAWBInvalid/markAWBInvalid.component.js